import { CUSTOMER_LOADING, CUSTOMER_SUCCESS, CUSTOMER_ERROR } from "../actions/actionCustomer";
import { apiCustomer } from 'api';
import { put, takeEvery } from 'redux-saga/effects';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get customer, response status: " + response.status + "\"}]}")
    }
}

function* fetchCustomer(action) {
    try {
        const data = yield fetchAsync(apiCustomer, action)
        yield put({ type: CUSTOMER_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: CUSTOMER_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaCustomer = [
    takeEvery(CUSTOMER_LOADING, fetchCustomer)
];
